import DateRangeMenu from 'src/components/Overlays/DateRangeMenu'

import { serializeDateRangeForUrl, updateUrl } from '../utils'

import Filters from './Filters'

const FiltersBar = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  callDirections,
  setCallDirections,
  selectedRecruiters,
  setSelectedRecruiters,
  callTypes,
  setCallTypes,
  callStatuses,
  setCallStatuses,
  selectedConnectedStatus,
  setSelectedConnectedStatus,
}) => {
  return (
    <div className="flex flex-row items-center gap-2">
      <Filters
        callDirections={callDirections}
        setCallDirections={setCallDirections}
        selectedRecruiters={selectedRecruiters}
        setSelectedRecruiters={setSelectedRecruiters}
        callTypes={callTypes}
        setCallTypes={setCallTypes}
        callStatuses={callStatuses}
        setCallStatuses={setCallStatuses}
        selectedConnectedStatus={selectedConnectedStatus}
        setSelectedConnectedStatus={setSelectedConnectedStatus}
      />

      <DateRangeMenu
        startDate={startDate}
        endDate={endDate}
        handleChange={(value) => {
          setStartDate(value[0])
          setEndDate(value[1])
          updateUrl('dateRange', serializeDateRangeForUrl(value[0], value[1]))
        }}
        clearable={false}
      />
    </div>
  )
}

export default FiltersBar
